<template>
  <div class="locations-tariffs">
    <h3 class="vz-text-align-left">Скачать тарифы грузоперевозок в {{ locationText }}</h3>
    <vz-button
      large
      variant="primary"
      class="mt-30"
      icon-name="tray-arrow-down"
      @click="onClick"
    >
      Тарифы
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { getTariffs } from "~/api/tariffs"
import { useCityStore } from "~/stores/city"
import { ftpServerUrl } from "~/api/constant-urls"

const { $showToast } = useNuxtApp()
const { from, to } = storeToRefs(useCityStore())

const locationText = computed(() => {
  return from.value.prepositional_name || `${from.value.type}. ${from.value.name}`
})

async function onClick(): Promise<void> {
  const tariffs = await getTariffs({
    from: [from.value.guid],
    to: [],
    orgId: ''
  })
  if (tariffs?.length) {
    $showToast({
      title: 'Загрузка',
      text: 'Данные сформированы, загрузка началась',
      variant: 'success',
    })
    window.open(`${ftpServerUrl}${tariffs}`, '_blank')
  }
}
</script>

<style lang="scss" scoped>
.locations-tariffs {
  .vz-button {
    max-width: 296px;
    width: 100%;
    justify-content: center;
  }
}
</style>